import React from 'react';
import {
  productDetails,
  ProductUpSellAndOrderSummary,
} from '../../interface/commonInterface';
import { IOrdersProductDetails } from './OrderSummary';
import { viewPorts } from '../../utils/helper';
interface CartItemProps {
  product: ProductUpSellAndOrderSummary;
  symbol: string;
  productDetailsData: IOrdersProductDetails;
  width: number;
}

export const CartItemThankYouPage: React.FC<CartItemProps> = ({
  product,
  symbol,
  productDetailsData,
  width,
}) => {
  let productItem: productDetails | null = null;
  try {
    productItem = JSON.parse(product.productDetails);
  } catch (error) {
    productItem = null;
  }

  return (
    <li key={product.subTitle} className="flex items-center space-x-4 py-6">
      <div style={{ position: 'relative' }}>
        <img
          width={500}
          height={500}
          src={productItem?.image_url ? productItem?.image_url : ''}
          alt={product?.subTitle}
          className="w-20 flex-none rounded-md object-cover object-center aspect-square min-w-[5rem]"
        />
        {(productDetailsData?.productQuantity?.showOnMobile &&
          width &&
          width <= viewPorts.mobile) ||
        (productDetailsData?.productQuantity?.showOnTablet &&
          width &&
          width > viewPorts.mobile &&
          width <= viewPorts.tablet) ||
        (productDetailsData?.productQuantity?.showOnDesktop &&
          width &&
          width > viewPorts?.tablet) ? (
          <div
            className={`quantity-bubble-bg absolute top-0 right-0 min-w-5 min-h-5 px-1 py-0.5 rounded-full bg-black flex items-center justify-center -mt-2 -mr-2 ${productDetailsData?.productQuantity?.fontSize} ${productDetailsData?.productQuantity?.fontWeight}`}
            style={{
              color: productDetailsData?.productQuantity?.textColor,
            }}>
            {product?.quantity}
          </div>
        ) : null}
      </div>
      {(productDetailsData?.productName?.showOnMobile &&
        width &&
        width <= viewPorts.mobile) ||
      (productDetailsData?.productName?.showOnTablet &&
        width &&
        width > viewPorts.mobile &&
        width <= viewPorts.tablet) ||
      (productDetailsData?.productName?.showOnDesktop &&
        width &&
        width > viewPorts?.tablet) ? (
        <div
          className={`flex-auto space-y-1 ${productDetailsData?.productName.fontWeight}`}
          style={{
            color: productDetailsData?.productName.textColor,
          }}>
          <h3 className={`${productDetailsData?.productName.fontSize}`}>
            {product?.productName}
          </h3>

          <p className="font-normal">{product?.subTitle}</p>
        </div>
      ) : null}
      {(productDetailsData?.productName?.showOnMobile &&
        width &&
        width <= viewPorts.mobile) ||
      (productDetailsData?.productName?.showOnTablet &&
        width &&
        width > viewPorts.mobile &&
        width <= viewPorts.tablet) ||
      (productDetailsData?.productName?.showOnDesktop &&
        width &&
        width > viewPorts?.tablet) ? (
        <div
          style={{
            color: productDetailsData?.productPrice.textColor,
          }}>
          {productItem?.discount_amount &&
          productItem?.discount_amount !== '0.00' ? (
            <>
              <p
                id="discounted-price"
                className={`flex-none text-sm font-normal ${productDetailsData?.productPrice.fontWeight} ${productDetailsData?.productPrice.fontSize}`}>
                {symbol}
                {(product?.productPrice * product?.quantity).toFixed(2)}
              </p>
              <p
                className={`flex-none text-sm font-normal ml-2 ${productDetailsData?.productPrice.fontWeight} ${productDetailsData?.productPrice.fontSize}`}>
                <span style={{ textDecoration: 'line-through', color: 'gray' }}>
                  {symbol}
                  {(
                    parseFloat(productItem?.discount_amount) +
                    product?.quantity * product?.productPrice
                  ).toFixed(2)}
                </span>
              </p>
            </>
          ) : (
            <p
              className={`flex-none text-nowrap ${productDetailsData?.productPrice.fontWeight} ${productDetailsData?.productPrice.fontSize}`}>
              {symbol}
              {(product?.productPrice * product?.quantity).toFixed(2)}
            </p>
          )}
        </div>
      ) : null}
    </li>
  );
};
